// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
li {
  font-family: "Inter", sans-serif;
}

.BookingDetailsPage_booking-details-container__iFRUG {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  font-family: "Inter", sans-serif;
  overflow: visible;
}
@media (max-width: 767px) {
  .BookingDetailsPage_booking-details-container__iFRUG {
    padding: 2rem 0.3rem;
  }
}

.BookingDetailsPage_booking-details__ymtiy {
  width: 100%;
}
.BookingDetailsPage_booking-details__header__DWXFJ {
  text-align: left;
  margin-bottom: 2rem;
}
@media (max-width: 767px) {
  .BookingDetailsPage_booking-details__header__DWXFJ {
    text-align: center;
  }
}
@media (max-width: 980px) {
  .BookingDetailsPage_booking-details__header__DWXFJ {
    text-align: center;
  }
}
.BookingDetailsPage_booking-details__title__x1Z\\+u {
  font-size: 2.25rem;
  font-weight: 600;
  color: #000000;
  margin: 0 0 0.5rem 0;
}
@media (max-width: 767px) {
  .BookingDetailsPage_booking-details__title__x1Z\\+u {
    font-size: 1.8rem;
  }
}
.BookingDetailsPage_booking-details__subtitle__ns6tz {
  font-size: 1.1rem;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.68);
  margin: 0;
}
.BookingDetailsPage_booking-details__divider__Ibq-H {
  border: 0;
  height: 1px;
  background-color: #A4A4A4;
  margin: 2rem 0;
}
@media (max-width: 767px) {
  .BookingDetailsPage_booking-details__divider__Ibq-H {
    display: none !important;
  }
}
.BookingDetailsPage_booking-details__grid__6-RJ4 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2.5rem;
}
@media (max-width: 767px) {
  .BookingDetailsPage_booking-details__grid__6-RJ4 {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-top: 5rem;
  }
}
@media (max-width: 1200px) {
  .BookingDetailsPage_booking-details__grid__6-RJ4 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 980px) {
  .BookingDetailsPage_booking-details__grid__6-RJ4 {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-top: 5rem;
  }
}

.BookingDetailsPage_doctor-card__Bksew {
  display: flex;
  align-items: center;
  gap: 2.2rem;
}
.BookingDetailsPage_doctor-card__avatar__MB-Ny {
  width: 238px;
  height: 238px;
  border-radius: 50%;
  object-fit: cover;
}
.BookingDetailsPage_doctor-card__info__tS-z1 {
  flex-grow: 1;
}
.BookingDetailsPage_doctor-card__name__dkkxj {
  font-size: 1.5rem;
  font-weight: 600;
  color: #466079;
  margin: 0;
}
.BookingDetailsPage_doctor-card__specialty__U2AjT {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.72);
  font-weight: 300;
  margin: 0;
}
.BookingDetailsPage_doctor-card__button__GPMXc {
  background: linear-gradient(to right, #3D7EBE, #495867);
  color: white;
  border: none;
  padding: 0.6rem 2.6rem;
  font-size: 0.9rem;
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.BookingDetailsPage_doctor-card__button__GPMXc:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(63, 120, 176, 0.3);
}
@media (max-width: 767px) {
  .BookingDetailsPage_doctor-card__Bksew {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .BookingDetailsPage_doctor-card__avatar__MB-Ny {
    width: 160px;
    height: 160px;
  }
  .BookingDetailsPage_doctor-card__button__GPMXc {
    width: 100%;
    justify-content: center;
    padding: 0.8rem;
    margin-top: 1rem;
  }
}
@media (max-width: 980px) {
  .BookingDetailsPage_doctor-card__Bksew {
    flex-direction: column;
    text-align: center;
    gap: 2.5rem;
  }
  .BookingDetailsPage_doctor-card__name__dkkxj {
    font-size: 2.1rem;
  }
  .BookingDetailsPage_doctor-card__specialty__U2AjT {
    font-size: 1.3rem;
  }
}

.BookingDetailsPage_detail-column__title__2tb7R {
  font-size: 1.2rem;
  font-weight: 600;
  color: #475E75;
  margin: 0 0 1.5rem 0;
}
@media (max-width: 767px) {
  .BookingDetailsPage_detail-column__VE2fm:nth-child(1), .BookingDetailsPage_detail-column__VE2fm:nth-child(2) {
    border-bottom: 1px solid #A4A4A4;
  }
  .BookingDetailsPage_detail-column__title__2tb7R {
    margin: 0 0 0.8rem 0;
  }
}

.BookingDetailsPage_detail-item__HjLs2 {
  margin-bottom: 1.5rem;
}
.BookingDetailsPage_detail-item__label__3\\+4tY {
  display: block;
  font-size: 0.9rem;
  color: #62ABF4;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.BookingDetailsPage_detail-item__value__7zgn0 {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.82);
  margin: 0;
  line-height: 1.5;
}
.BookingDetailsPage_detail-item__button-views-more__QWTdf {
  background: none;
  border: none;
  padding: 0;
  margin-top: 8px;
  color: #007bff;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}
.BookingDetailsPage_detail-item__button-views-more__QWTdf:hover {
  text-decoration: underline;
}

.BookingDetailsPage_detail-item-status__OKMXM {
  display: flex;
  align-items: center;
  gap: 1.4rem;
}
.BookingDetailsPage_detail-item-status__label__vNLPH {
  display: block;
  font-size: 0.9rem;
  color: #62ABF4;
  font-weight: 500;
  margin-bottom: 0rem;
}
.BookingDetailsPage_detail-item-status__value__a1MG1 {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.82);
  margin: 0;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .BookingDetailsPage_detail-item-status__OKMXM {
    margin-bottom: 2rem;
  }
}

.BookingDetailsPage_status-badge__nBJeH {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.65rem 0.25rem 0.35rem;
  border-radius: 9999px;
  font-size: 0.8rem;
  font-weight: 400;
}
.BookingDetailsPage_status-badge--confirmed__HDtl2 {
  background-color: #2EC114;
  color: white;
}
.BookingDetailsPage_status-badge--confirmed__HDtl2 svg {
  color: currentColor;
}
.BookingDetailsPage_status-badge--pending__dubbv {
  background-color: #c1be14;
  color: white;
}
.BookingDetailsPage_status-badge--pending__dubbv svg {
  color: currentColor;
}

.BookingDetailsPage_direction-info__V28\\+z {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  color: #1e293b;
}
.BookingDetailsPage_direction-info__icon__m3UEP {
  color: #64748b;
}
.BookingDetailsPage_direction-info__text__Xf3o4 {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.82);
  margin: 0;
  line-height: 1.5;
}

.BookingDetailsPage_payment-toast__TJ4R2 {
  position: fixed;
  left: 24px;
  bottom: 24px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 18px;
  border-radius: var(--bw-radius-lg, 18px);
  background: var(--bw-card-surface, #F7F5F1);
  border: 1px solid rgba(130, 177, 148, 0.28);
  box-shadow: 0 18px 34px rgba(18, 34, 28, 0.12);
  z-index: 9999;
  width: min(520px, 100% - 48px);
}
.BookingDetailsPage_payment-toast__TJ4R2 .BookingDetailsPage_bw-toast__close__ZTkiV {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.BookingDetailsPage_payment-toast__TJ4R2 .BookingDetailsPage_bw-toast__close__ZTkiV:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.BookingDetailsPage_bw-toast__close__ZTkiV {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.BookingDetailsPage_bw-toast__close__ZTkiV:hover {
  background-color: rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/pages/BookingDetailsPage/BookingDetailsPage.module.scss"],"names":[],"mappings":"AAiDA;;;;;;;;;EASI,gCAxDU;AASd;;AAoDA;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAlEU;EAmEV,iBAAA;AAjDJ;AAgBQ;EA2BR;IASQ,oBAAA;EAhDN;AACF;;AAmDA;EACI,WAAA;AAhDJ;AAkDI;EACI,gBAAA;EACA,mBAAA;AAhDR;AAGQ;EA2CJ;IAKQ,kBAAA;EA/CV;AACF;AAIQ;EAqCJ;IASQ,kBAAA;EA9CV;AACF;AAiDI;EACI,kBAAA;EACA,gBAAA;EACA,cAzFa;EA0Fb,oBAAA;AA/CR;AAbQ;EAwDJ;IAOQ,iBAAA;EA9CV;AACF;AAiDI;EACI,iBAAA;EACA,gBAAA;EACA,0BAnGiB;EAoGjB,SAAA;AA/CR;AAkDI;EACI,SAAA;EACA,WAAA;EACA,yBApGQ;EAqGR,cAAA;AAhDR;AA9BQ;EA0EJ;IAOQ,wBAAA;EA/CV;AACF;AAkDI;EACI,aAAA;EACA,qCAAA;EACA,WAAA;AAhDR;AAxCQ;EAqFJ;IAMQ,0BAAA;IACA,SAAA;IACA,gBAAA;EA/CV;AACF;AArDQ;EA2FJ;IAYQ,qCAAA;EA9CV;AACF;AA9CQ;EA+EJ;IAgBQ,0BAAA;IACA,SAAA;IACA,gBAAA;EA7CV;AACF;;AAkDA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AA/CJ;AAiDI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AA/CR;AAkDI;EACI,YAAA;AAhDR;AAmDI;EACI,iBAAA;EACA,gBAAA;EACA,cA5JY;EA6JZ,SAAA;AAjDR;AAoDI;EACI,eAAA;EACA,0BAjKiB;EAkKjB,gBAAA;EACA,SAAA;AAlDR;AAqDI;EACI,uDAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAnDR;AAqDQ;EACI,2BAAA;EACA,8CAAA;AAnDZ;AAzGQ;EA6GR;IAoDQ,sBAAA;IACA,kBAAA;IACA,SAAA;EApDN;EAsDM;IACI,YAAA;IACA,aAAA;EApDV;EAuDM;IACI,WAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;EArDV;AACF;AApHQ;EAuGR;IAsEQ,sBAAA;IACA,kBAAA;IACA,WAAA;EArDN;EAuDM;IACI,iBAAA;EArDV;EAwDM;IACI,iBAAA;EAtDV;AACF;;AA2DI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAxDR;AA9IQ;EA2MA;IAEI,gCAAA;EA3DV;EA8DM;IACI,oBAAA;EA5DV;AACF;;AAgEA;EACI,qBAAA;AA7DJ;AA+DI;EACI,cAAA;EACA,iBAAA;EACA,cArPqB;EAsPrB,gBAAA;EACA,sBAAA;AA7DR;AAgEI;EACI,eAAA;EACA,0BA7PW;EA8PX,SAAA;EACA,gBAAA;AA9DR;AAiEI;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA/DR;AAiEQ;EACI,0BAAA;AA/DZ;;AAoEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAjEJ;AAmEI;EACI,cAAA;EACA,iBAAA;EACA,cAzRqB;EA0RrB,gBAAA;EACA,mBAAA;AAjER;AAoEI;EACI,eAAA;EACA,0BAjSW;EAkSX,SAAA;EACA,gBAAA;AAlER;AAvMQ;EAwPR;IAqBQ,mBAAA;EAlEN;AACF;;AAqEA;EACI,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAlEJ;AAoEI;EACI,yBA5SoB;EA6SpB,YA3SsB;AAyO9B;AAoEQ;EACI,mBAAA;AAlEZ;AAsEI;EACI,yBApTkB;EAqTlB,YApTsB;AAgP9B;AAsEQ;EACI,mBAAA;AApEZ;;AAyEA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAlViB;AA4QrB;AAwEI;EACI,cApVe;AA8QvB;AAyEI;EACI,eAAA;EACA,0BApVW;EAqVX,SAAA;EACA,gBAAA;AAvER;;AA2EA;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,2CAAA;EACA,2CAAA;EACA,8CAAA;EACA,aAAA;EACA,8BAAA;AAxEJ;AA0EI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,cAtXe;EAuXf,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AAxER;AA0EQ;EACI,qCAAA;AAxEZ;;AA6EA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,cA3YmB;EA4YnB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AA1EJ;AA4EI;EACI,qCAAA;AA1ER","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\n\n$font-family: 'Inter', sans-serif;\n\n$color-text-primary: #1e293b;\n$color-text-secondary: #64748b;\n$color-heading-main: #000000;\n$color-heading-subtitle: rgba($color-heading-main, 0.68);\n$color-doctor-name: #466079;\n$color-doctor-specialty: rgba($color-heading-main, 0.72);\n$color-item-value: rgba($color-heading-main, 0.82);\n$color-text-label-highlight: #62ABF4;\n\n$color-divider: #A4A4A4;\n$color-border: #e5e7eb;\n\n$color-button-gradient-start: #3D7EBE;\n$color-button-gradient-end: #495867;\n\n$color-status-confirmed-bg: #2EC114;\n$color-status-pending-bg: #c1be14;\n$color-status-confirmed-text: white;\n\n$breakpoint-xl: 980px;\n$breakpoint-md: 1200px;\n$breakpoint-xs: 767px;\n\n\n@mixin respond-to($breakpoint-name) {\n    @if $breakpoint-name ==tablet {\n        @media (max-width: $breakpoint-md) {\n            @content;\n        }\n    }\n\n    @else if $breakpoint-name ==mobile {\n        @media (max-width: $breakpoint-xs) {\n            @content;\n        }\n    }\n\n    @else if $breakpoint-name ==pc-xs {\n        @media (max-width: $breakpoint-xl) {\n            @content;\n        }\n    }\n}\n\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\na,\nli {\n    font-family: $font-family;\n}\n\n\n\n.booking-details-container {\n    display: flex;\n    justify-content: center;\n    min-height: 100vh;\n    position: relative;\n    font-family: $font-family;\n    overflow: visible;\n\n    @include respond-to(mobile) {\n        padding: 2rem 0.3rem;\n    }\n}\n\n.booking-details {\n    width: 100%;\n\n    &__header {\n        text-align: left;\n        margin-bottom: 2rem;\n\n        @include respond-to(mobile) {\n            text-align: center;\n        }\n\n        @include respond-to(pc-xs) {\n            text-align: center;\n        }\n    }\n\n    &__title {\n        font-size: 2.25rem;\n        font-weight: 600;\n        color: $color-heading-main;\n        margin: 0 0 0.5rem 0;\n\n        @include respond-to(mobile) {\n            font-size: 1.8rem;\n        }\n    }\n\n    &__subtitle {\n        font-size: 1.1rem;\n        font-weight: 300;\n        color: $color-heading-subtitle;\n        margin: 0;\n    }\n\n    &__divider {\n        border: 0;\n        height: 1px;\n        background-color: $color-divider;\n        margin: 2rem 0;\n\n        @include respond-to(mobile) {\n            display: none !important;\n        }\n    }\n\n    &__grid {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 2.5rem;\n\n        @include respond-to(mobile) {\n            grid-template-columns: 1fr;\n            gap: 2rem;\n            margin-top: 5rem;\n        }\n\n        @include respond-to(tablet) {\n            grid-template-columns: repeat(2, 1fr);\n        }\n\n        @include respond-to(pc-xs) {\n            grid-template-columns: 1fr;\n            gap: 2rem;\n            margin-top: 5rem;\n        }\n\n    }\n}\n\n.doctor-card {\n    display: flex;\n    align-items: center;\n    gap: 2.2rem;\n\n    &__avatar {\n        width: 238px;\n        height: 238px;\n        border-radius: 50%;\n        object-fit: cover;\n    }\n\n    &__info {\n        flex-grow: 1;\n    }\n\n    &__name {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: $color-doctor-name;\n        margin: 0;\n    }\n\n    &__specialty {\n        font-size: 1rem;\n        color: $color-doctor-specialty;\n        font-weight: 300;\n        margin: 0;\n    }\n\n    &__button {\n        background: linear-gradient(to right, $color-button-gradient-start, $color-button-gradient-end);\n        color: white;\n        border: none;\n        padding: 0.6rem 2.6rem;\n        font-size: 0.9rem;\n        font-weight: 400;\n        border-radius: 6px;\n        cursor: pointer;\n        transition: transform 0.2s, box-shadow 0.2s;\n        margin-top: 2rem;\n        display: inline-flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        &:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 4px 15px rgba(63, 120, 176, 0.3);\n        }\n    }\n\n    @include respond-to(mobile) {\n        flex-direction: column;\n        text-align: center;\n        gap: 1rem;\n\n        &__avatar {\n            width: 160px;\n            height: 160px;\n        }\n\n        &__button {\n            width: 100%;\n            justify-content: center;\n            padding: 0.8rem;\n            margin-top: 1rem;\n        }\n    }\n\n    @include respond-to(pc-xs) {\n        flex-direction: column;\n        text-align: center;\n        gap: 2.5rem;\n\n        &__name {\n            font-size: 2.1rem;\n        }\n\n        &__specialty {\n            font-size: 1.3rem;\n        }\n    }\n}\n\n.detail-column {\n    &__title {\n        font-size: 1.2rem;\n        font-weight: 600;\n        color: #475E75;\n        margin: 0 0 1.5rem 0;\n    }\n\n    @include respond-to(mobile) {\n\n        &:nth-child(1),\n        &:nth-child(2) {\n            border-bottom: 1px solid $color-divider;\n        }\n\n        &__title {\n            margin: 0 0 0.8rem 0;\n        }\n    }\n}\n\n.detail-item {\n    margin-bottom: 1.5rem;\n\n    &__label {\n        display: block;\n        font-size: 0.9rem;\n        color: $color-text-label-highlight;\n        font-weight: 500;\n        margin-bottom: 0.25rem;\n    }\n\n    &__value {\n        font-size: 1rem;\n        color: $color-item-value;\n        margin: 0;\n        line-height: 1.5;\n    }\n\n    &__button-views-more {\n        background: none;\n        border: none;\n        padding: 0;\n        margin-top: 8px;\n        color: #007bff;\n        cursor: pointer;\n        font-weight: bold;\n        font-size: 14px;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n\n.detail-item-status {\n    display: flex;\n    align-items: center;\n    gap: 1.4rem;\n\n    &__label {\n        display: block;\n        font-size: 0.9rem;\n        color: $color-text-label-highlight;\n        font-weight: 500;\n        margin-bottom: 0rem;\n    }\n\n    &__value {\n        font-size: 1rem;\n        color: $color-item-value;\n        margin: 0;\n        line-height: 1.5;\n    }\n\n    @include respond-to(mobile) {\n        margin-bottom: 2rem;\n    }\n}\n\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.25rem 0.65rem 0.25rem 0.35rem;\n    border-radius: 9999px;\n    font-size: 0.8rem;\n    font-weight: 400;\n\n    &--confirmed {\n        background-color: $color-status-confirmed-bg;\n        color: $color-status-confirmed-text;\n\n        svg {\n            color: currentColor;\n        }\n    }\n\n    &--pending {\n        background-color: $color-status-pending-bg;\n        color: $color-status-confirmed-text;\n\n        svg {\n            color: currentColor;\n        }\n    }\n}\n\n.direction-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    font-size: 1rem;\n    color: $color-text-primary;\n\n    &__icon {\n        color: $color-text-secondary;\n    }\n\n    &__text {\n        font-size: 1rem;\n        color: $color-item-value;\n        margin: 0;\n        line-height: 1.5;\n    }\n}\n\n.payment-toast {\n    position: fixed;\n    left: 24px;\n    bottom: 24px;\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n    padding: 16px 18px;\n    border-radius: var(--bw-radius-lg, 18px);\n    background: var(--bw-card-surface, #F7F5F1);\n    border: 1px solid rgba(130, 177, 148, .28);\n    box-shadow: 0 18px 34px rgba(18, 34, 28, .12);\n    z-index: 9999;\n    width: min(520px, calc(100% - 48px));\n\n    .bw-toast__close {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 4px;\n        color: $color-text-secondary;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        transition: background-color 0.2s;\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.05);\n        }\n    }\n}\n\n.bw-toast__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    color: $color-text-secondary;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n\n    &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"booking-details-container": `BookingDetailsPage_booking-details-container__iFRUG`,
	"booking-details": `BookingDetailsPage_booking-details__ymtiy`,
	"booking-details__header": `BookingDetailsPage_booking-details__header__DWXFJ`,
	"booking-details__title": `BookingDetailsPage_booking-details__title__x1Z+u`,
	"booking-details__subtitle": `BookingDetailsPage_booking-details__subtitle__ns6tz`,
	"booking-details__divider": `BookingDetailsPage_booking-details__divider__Ibq-H`,
	"booking-details__grid": `BookingDetailsPage_booking-details__grid__6-RJ4`,
	"doctor-card": `BookingDetailsPage_doctor-card__Bksew`,
	"doctor-card__avatar": `BookingDetailsPage_doctor-card__avatar__MB-Ny`,
	"doctor-card__info": `BookingDetailsPage_doctor-card__info__tS-z1`,
	"doctor-card__name": `BookingDetailsPage_doctor-card__name__dkkxj`,
	"doctor-card__specialty": `BookingDetailsPage_doctor-card__specialty__U2AjT`,
	"doctor-card__button": `BookingDetailsPage_doctor-card__button__GPMXc`,
	"detail-column__title": `BookingDetailsPage_detail-column__title__2tb7R`,
	"detail-column": `BookingDetailsPage_detail-column__VE2fm`,
	"detail-item": `BookingDetailsPage_detail-item__HjLs2`,
	"detail-item__label": `BookingDetailsPage_detail-item__label__3+4tY`,
	"detail-item__value": `BookingDetailsPage_detail-item__value__7zgn0`,
	"detail-item__button-views-more": `BookingDetailsPage_detail-item__button-views-more__QWTdf`,
	"detail-item-status": `BookingDetailsPage_detail-item-status__OKMXM`,
	"detail-item-status__label": `BookingDetailsPage_detail-item-status__label__vNLPH`,
	"detail-item-status__value": `BookingDetailsPage_detail-item-status__value__a1MG1`,
	"status-badge": `BookingDetailsPage_status-badge__nBJeH`,
	"status-badge--confirmed": `BookingDetailsPage_status-badge--confirmed__HDtl2`,
	"status-badge--pending": `BookingDetailsPage_status-badge--pending__dubbv`,
	"direction-info": `BookingDetailsPage_direction-info__V28+z`,
	"direction-info__icon": `BookingDetailsPage_direction-info__icon__m3UEP`,
	"direction-info__text": `BookingDetailsPage_direction-info__text__Xf3o4`,
	"payment-toast": `BookingDetailsPage_payment-toast__TJ4R2`,
	"bw-toast__close": `BookingDetailsPage_bw-toast__close__ZTkiV`
};
export default ___CSS_LOADER_EXPORT___;
